// extracted by mini-css-extract-plugin
export default {"activeView":"ViewList_activeView__4NKdz"};